import React, { useState } from 'react';
import MasterSupportingDocumentTable from '../components/MasterSupportingDocumentTable';
import MasterSupportingDocumentDetailPage from './MasterSupportingDocumentDetailPage';
import DefaultModal from 'components/Modal/DefaultModal';
import Button from 'components/Button/Button';

const MasterSupportingDocumentPage = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);

    const toggleModal = () => {
        setShowModal((prevState) => !prevState);
    };

    const openModal = (isEdit: boolean) => {
        setIsEdit(isEdit);
        setShowModal(true);
    };

    return (
        <div className="p-2 md:p-10 bg-white dark:border-gray-700 dark:bg-gray-800 rounded-2xl">
            <div className="flex justify-items-center">
                <h1 className="text-lg leading-10 grow font-medium truncate mr-5 dark:text-gray-300">
                    Master Supporting Document
                </h1>
                <div className="">
                    <Button
                        title="New Document"
                        onClick={() => openModal(false)}
                    />
                </div>
            </div>
            <div className="mt-3">
                <MasterSupportingDocumentTable openModal={openModal} />

                <DefaultModal
                    title="Supporting Document"
                    show={showModal}
                    onClose={toggleModal}
                    body={
                        <MasterSupportingDocumentDetailPage
                            isEdit={isEdit}
                            toggleModal={toggleModal}
                        />
                    }
                />
            </div>
        </div>
    );
};

export default MasterSupportingDocumentPage;
